import { useCallback, useState } from 'react';
import * as Sentry from '@sentry/react';

import { axiosRubyClient } from '@/util/axios/axiosClient';

interface RecallBroadcastResponse {
  success: boolean;
  data: { broadcast_id: string; recalled_at: string };
  errors?: string[];
}

export function useRecallBroadcast() {
  const [recalling, setRecalling] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const recall = useCallback(async (broadcastId: string) => {
    setRecalling(true);
    setError(null);
    try {
      const res = await axiosRubyClient.delete<RecallBroadcastResponse>(
        `/api/admin/broadcasts/${broadcastId}`,
      );
      return res.data.data;
    } catch (err: unknown) {
      const message =
        (
          err as { response?: { data?: { errors?: string[] } } }
        )?.response?.data?.errors?.join(', ') ??
        (err as Error)?.message ??
        'Failed to recall broadcast';
      Sentry.captureException(err, {
        tags: { feature: 'comms', action: 'recall_broadcast' },
        extra: { broadcast_id: broadcastId },
      });
      setError(message);
      throw err;
    } finally {
      setRecalling(false);
    }
  }, []);

  return { recall, recalling, error };
}
